import Vue from 'vue'

const recettes = {
  namespaced: true,
  state: {
    lastRecette: {},
    recette: {},
    filtresEnMemoire: {
      categorieIdsEnMemoire: [],
      composanteIdsEnMemoire: [],
      regimeIdsEnMemoire: [],
      textureIdsEnMemoire: [],
      typeDeRechercheEnMemoire: '',
      termeDeRechercheEnMemoire: '',
    }
  },
  mutations: {
    setItems(state, items) {
      Vue.set(state, items.key, items["data"])
    },
    setFiltresEnMemoire(state, item) {
      Vue.set(state.filtresEnMemoire, item.key, item["data"])
    }
  }
}

export default recettes
